/* eslint-disable prefer-destructuring */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */

export const libs = {
  youtube: {
    tester: (url) => url.match(/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/|shorts\/)?([a-z0-9\-_%]+)/i),
    getCover: (id) => `https://img.youtube.com/vi/${id}/hqdefault.jpg`,
    getUrl: (id, autoplay = '1') => `https://www.youtube.com/embed/${id}?wmode=opaque&autoplay=${autoplay}&enablejsapi=1`
  },
  vimeo: {
    tester: (url) => url.match(/(?:www\.)?vimeo.com\/([0-9a-z\-_]+)/i),
    getCover: () => '',
    // getCover: async (id) => {
    //   let res = ''
    //   try {
    //     let tmp = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${id}`)
    //     tmp = await res.json()
    //     res = tmp.thumbnail_url
    //   } catch(err) { /**/ }
      
    //   return res
    // },
    getUrl: (id, autoplay = '1') => `https://player.vimeo.com/video/${id}?autoplay=${autoplay}&api=1`
  },
  dailymotion: {
    tester: (url) => url.match(/(?:www\.)?dai.ly\/([0-9a-z\-_]+)/i),
    getCover: (id) => `https://www.dailymotion.com/thumbnail/video/${id}`,
    getUrl: (id, autoplay = '1') => `https://www.dailymotion.com/embed/video/${id}?wmode=opaque&autoplay=${autoplay}&api=postMessage`
  },
  vk: {
    tester: (url) => url.match(/(?:www\.)?(?:vk\.com|vkontakte\.ru)\/(?:video_ext\.php\?)(.*)/i),
    getCover: () => '',
    getUrl: (id, autoplay = '1') => `http://vk.com/video_ext.php?${id}?autoplay=${autoplay}`
  },
}

export function getParser(videoUrl) {
  let partten
  let parser

  for(const key in libs) {
    partten = libs[key].tester(videoUrl)
    if(partten?.length > 1) {
      parser = libs[key]
      break
    }
  }

  return { parser, partten }
}

export function getVideoUrl(videoUrl, autoplay) {
  const { partten, parser } = getParser(videoUrl)
  return parser ? parser.getUrl(partten[1], autoplay) : ''
}

export function getVideoId(videoUrl) {
  const { parser, partten } = getParser(videoUrl)
  return parser ? partten[1] : ''
}

export function getVideoCover(videoUrl) {
  let cover = ''
  const { parser, partten } = getParser(videoUrl)

  parser && (cover = parser.getCover(partten[1]))
  return cover
}

/**
 * 解析 url 并返回适用于iframe的url 与 id
 * @param {String} videoUrl 视频地址
 * @return {Object} { url, id }
 */
export function getVideoObj(videoUrl, autoplay) {
  const { parser, partten } = getParser(videoUrl)
  
  if(parser) {
    const id = partten[1]
    const cover = parser.getCover(id)
    const url = parser.getUrl(id, autoplay)

    return { id, url, cover }
  }

  return {}
}
